import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function SignalGauge() {
  const [needleAngle, setNeedleAngle] = useState(-90);
  useEffect(() => {
    setNeedleAngle(-18);
  }, []);
  const radius = 100;
  const strokeWidth = 20;
  const centerX = 150;
  const centerY = 150;
  const zones = [{
    color: '#ef4444',
    startAngle: -90,
    endAngle: -54,
    label: 'Avoid'
  }, {
    color: '#f97316',
    startAngle: -54,
    endAngle: -18,
    label: 'Weak'
  }, {
    color: '#a3a3a3',
    startAngle: -18,
    endAngle: 18,
    label: 'Hold'
  }, {
    color: '#facc15',
    startAngle: 18,
    endAngle: 54,
    label: 'Moderate Buy'
  }, {
    color: '#22c55e',
    startAngle: 54,
    endAngle: 90,
    label: 'Strong Buy'
  }];
  const polarToCartesian = (angle: number) => {
    const rad = angle * Math.PI / 180;
    return {
      x: centerX + radius * Math.cos(rad),
      y: centerY + radius * Math.sin(rad)
    };
  };
  const createArc = (startAngle: number, endAngle: number) => {
    const start = polarToCartesian(startAngle);
    const end = polarToCartesian(endAngle);
    const largeArc = endAngle - startAngle > 180 ? 1 : 0;
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArc} 1 ${end.x} ${end.y}`;
  };
  return <div className="flex flex-col items-center mb-12" data-id="element-47">
      <svg width="300" height="180" viewBox="0 0 300 180" className="mb-6" data-id="element-48">
        {zones.map((zone, index) => <path key={index} d={createArc(zone.startAngle, zone.endAngle)} fill="none" stroke={zone.color} strokeWidth={strokeWidth} strokeLinecap="round" opacity={0.3} data-id="element-49" />)}

        <motion.line x1={centerX} y1={centerY} x2={centerX} y2={centerY - radius + strokeWidth / 2} stroke="#facc15" strokeWidth="3" strokeLinecap="round" initial={{
        rotate: -90
      }} animate={{
        rotate: needleAngle
      }} transition={{
        type: 'spring',
        stiffness: 60,
        damping: 15,
        duration: 1.2
      }} style={{
        transformOrigin: `${centerX}px ${centerY}px`
      }} data-id="element-50" />

        <circle cx={centerX} cy={centerY} r="6" fill="#facc15" data-id="element-51" />
      </svg>

      <div className="text-center" data-id="element-52">
        <h2 className="text-3xl font-bold text-yellow-400 mb-2" data-id="element-53">
          Moderate Buy
        </h2>
        <p className="text-zinc-400 text-sm max-w-md" data-id="element-54">
          The story looks promising, but pace yourself.
        </p>
      </div>
    </div>;
}